export default import.meta.ROLLDOWN_FILE_URL_XVpAZF1orzj7PEuue70C4Q